module.exports = __webpack_public_path__ + "static/img/-tic-tac-toe.5db5a5ae.png";